import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { BgColorInterface } from './config/CommonInterfaces';
import { logout } from '../redux/ducks/userDuck';

import LinkButton from './LinkButton';
import Text from './Text';

import PagatodoLogo from '../tmp/pagatodo-logo.png';

const HeaderContainer = styled.header`
  backgroundColor: ${({ bg, theme: { colors } }) => colors.general[`${bg}`.toUpperCase()]}
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
`;

const Logo = styled.img``;

const OptionsContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

function Header({
  bgColor, email, logged,
  logout,
}) {
  return (
    <HeaderContainer bg={bgColor} className="header-component">
      <Nav>
        <Link to="/">
          <Logo src={PagatodoLogo} width="100" />
        </Link>
        <OptionsContainer className="options-header">
          {
            logged && (
              <Fragment>
                <Text textColor="highlight">
                  { `${email}`}
                </Text>
                <LinkButton flat onClick={() => logout()} textColor="highlight">
                  Salir
                </LinkButton>
              </Fragment>
            )
          }
        </OptionsContainer>
      </Nav>
    </HeaderContainer>
  );
}

function mapStateToProps({ user }) {
  return {
    email: user.email,
    logged: user.logged,
  }
}

export default connect(
  mapStateToProps, {
    logout,
  }
)(Header);

Header.defaultProps = {
  bgColor: 'light',
}
